/** @module Specification/AggregateInlineForProductSource */
define([
	"dojo/_base/declare",
	"csi",
	"csi/heading/AggregateController",
	"csi/page",
	"csi/state/rootStore",
	"csi/widget/MessageDialog"
], function(declare, csi, AggregateController, page, {routerStore}, MessageDialog) {

	return declare(AggregateController, {

		/**
		 * @override
		 *
		 * Set confirmation button to Change
		 */
		getConfirmButton: function() {
			return MessageDialog.BUTTON_CHANGE;
		},

		/**
		 * @override
		 *
		 * When new ForProductSource value is not empty and different from the previous value and (datapackage has data sheets or dataPackage has documents)
		 * Display confirmation message
		 */
		process: function() {
			var dataPackage = this.getNode();
			if (this.newValue && this.newValue != csi.EMPTY_URL && this.newValue != this.oldValue
				&& ((dataPackage.DataSheets && dataPackage.DataSheets.length > 0) || (dataPackage.DPDocuments && dataPackage.DPDocuments.length > 0))) {
				this.confirmAction();
			} else {
				this.inherited(arguments);
			}
		},

		/**
		 * @override
		 *
		 * process the change if user has confirmed
		 */
		onConfirm: function(key) {
			// summary: if configured to confirm action, then start now that confirmed
			if (key == MessageDialog.BUTTON_CHANGE) {
				AggregateController.prototype.process.call(this);
			} else {
				this.postProcess();
			}
		},

		// summary: change viewRef m_path to Child:__Parent__/Child:ProductSourcing for DATAPACKAGE FoodSKU  
		//TODO for future version we will need to improve this using aggregate store.
		getFormData: function() {
			if (this.getParent()?.$Type === "FoodSKU") {
				this.m_action.m_viewRef.m_path = "Child:__Parent__/Child:__Parent__/Child:ProductSourcing";
			}
			return this.inherited(arguments);
		},

		/**
		 * @override
		 *
		 * Refresh views, DataPackage is in breadcrumb trail, so that data sheets view is refreshed as well
		 * because data sheets that are for different product source are removed
		 */
		postProcessSuccess: function() {
			// summary: if DataPackage is in breadcrumb trail, then refresh all views
			if (routerStore.locationUrl == this.m_urlNode) {
				page.refreshViews();
			} else {
				this.inherited(arguments);
			}

		}
	});
});